// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ol-1";
export var messageSideRight = "_ol-2";
export var orderLookupBubbleContainer = "_ol-0";
export var submitButton = "_ol-3";